var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle1C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hairstyle:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M411.8,104.8L411.8,104.8L411.8,104.8C411.5,105,411.5,105,411.8,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M461.7,177.3c-1.3-4.3-3.1-8.2-6.7-10.9c5.1-1.8,13.8-1.8,19,0.8c-1.6-9.1-11.8-11.1-19.5-11.9 c5.1-7.7,3.3-18.6-1.5-26.6c-1.3,5.3-4.3,10.1-8.7,13.8c8-19.4,3.3-48.4-16.6-59c-0.1,9-7.7,18.8-15.8,21.4c0,0,0,0,0,0.1 c-0.2,0.2-0.2,0.2,0,0c0,0,0,0,0.1,0c8.6-11.1,1.7-24.6-8.9-32.1c-1.2,11.4-9.1,23.7-19.2,29.5c2.7-9.8,0.5-27.1-9.9-33.1 c-1.7,13.6-18.1,20.9-29,24.8c-15.3,5.5-33,4.8-48.4,10.6c-15.7,6-29,22.1-27.1,38.3c-3.8-6.1-7.5-11.6-4.5-18.6 c-13.1,8.5-18.8,28.9-8.8,40.4c-12.5,6.1-11.4,20.1-9.8,32.2c2.1,16.5,7.3,36.3,16.8,54.3c0.9,1.8,3.2,7.7,4.3,9.3 c-1.3-14.1,3.1-42,5.6-56.7c2.7-15.6,4.9-30.5,23.1-31.7c9.3-0.6,20,3.2,28.7,4.8c8,1.4,21.8,3.2,30.3,2.7 c16.7-1,26.6-4.5,40.4-8.8c19.3-5.9,18.7-7.5,30.3,8.2c10.6,14.4,17.6,42.8,19.2,59.8c0.9,10,1.7,22,6,30.1 C452.3,241,475.3,221.5,461.7,177.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M411.8,104.8L411.8,104.8L411.8,104.8C411.5,105,411.5,105,411.8,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M423.4,163.2c13.1,1,30.4-12.9,33.2-25.6c-0.8-3.2-2.1-6.2-3.7-8.9c-1.3,5.3-4.3,10.1-8.7,13.8 c0-0.1,0.1-0.1,0.1-0.2C438.9,151.3,431.2,161.3,423.4,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M423.3,163.2C423.4,163.2,423.4,163.2,423.3,163.2C423.4,163.2,423.3,163.2,423.3,163.2 C423.1,163.2,423.1,163.2,423.3,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M426.4,118.3c-13.4,13.6-29.3,21.5-47.7,25.4c-21.2,4.5-41.8,0.2-63.1-1.1c-10-0.6-19.4,0.8-28.1,5.7 c-5.4,3.1-14.4,9.6-16.7,16.4c5.6-5,11.8-7.9,20.4-8.2c18.5-0.6,35.4,5.3,53.7,5.3c19.7,0,39-1.1,55.9-12 c13-8.5,28.4-24.2,31.4-39.7C431,113.1,428.7,115.9,426.4,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M361.6,105.7c9.1-8.8,16.1-21.8,15.2-34.3c-0.9-0.8-1.9-1.6-2.9-2.2c-0.1,1.1-0.4,2.1-0.7,3 c-0.2,1.8-0.5,3.4-1.2,5.3c-2.8,7.9-8.5,15.2-15.6,20.2c-9.1,6.4-21.9,8.2-32.7,9.6c-11.2,1.4-23,4.3-33.9,7.1 c-8.6,2.3-13.8,7.4-18.4,14.1c-1.1,2.7-1.8,5.6-2.1,8.4c10.9-11.2,29.8-12.8,44.2-15.4C328.7,119,349.8,117.2,361.6,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77D4A",
    d: "M302.6,137.2c2.7-0.6,5.5-1,8.2-1.4c31.2-3.4,72.7-1.3,88.9-32.8c1.2-2.4,2.2-5.1,2.9-7.9 c-1.4,2.3-3,4.5-4.7,6.5c-20.9,23.3-53.9,22.3-82.7,25.5c-2.8,0.4-5.6,1-8.4,1.6c-15.9,3.5-30.4,10.5-37.1,26.4 C278.5,144.8,290.1,139.8,302.6,137.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC67D",
    d: "M374.7,96.4c-8.7,13.5-22.1,23.5-42.5,24.7c2.8,1.8,10.7,0.6,13.8,0c8.7-1.7,10.8-3.6,18.1-8.9 c5.4-4,16.6-16.4,14.6-23.8C378.2,91.4,376.4,93.9,374.7,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC67D",
    d: "M440.9,104.7c4.3,25.5-14.9,50-38.2,57.4c10-0.4,18.6-6.2,26-12.5C441.4,137.9,447.3,120.6,440.9,104.7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC67D",
    d: "M402.6,162.1L402.6,162.1c0,0-0.2,0-0.3,0H402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC67D",
    d: "M315.4,163.9c-13.8-3.4-36.7-8.2-45,8.8c0.4-0.4,2.8-2.3,4-3.1c13.9-9.4,33.6-3,48.6-0.1 c15.7,3,34.4,5.8,49.2-2.3c-1,0.5-2.2,0.8-3.4,1C352,171.2,331.6,167.9,315.4,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC67D",
    d: "M256.3,179.3c-3.2,11.1-3.9,21.5-1.5,33c2.3,10.8,8.5,21.4,8.9,32.3c2.4-5.3-0.6-14-2-18.9 c-6.7-23.2-5.4-47.3,8-68.2C262.1,163.1,258.8,170.7,256.3,179.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle1C);
export default __webpack_public_path__ + "static/media/man_hairstyle_1c.d65c91d23fabcf31da7673717894d90b.svg";
export { ForwardRef as ReactComponent };